import { render, staticRenderFns } from "./box6.vue?vue&type=template&id=76bc3714&"
import script from "./box6.vue?vue&type=script&lang=js&"
export * from "./box6.vue?vue&type=script&lang=js&"
import style0 from "./box6.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports